export function initFormPopup() {
    document.querySelectorAll<HTMLElement>(".form-item").forEach((formItem) => {
        const input = formItem.querySelector<HTMLInputElement>(".input-clue");
        const popup = formItem.querySelector<HTMLElement>(".form-popup");
        const popupItems = Array.from(
            formItem.querySelectorAll<HTMLElement>(".form-popup-item")
        );
        const popupSelect = formItem.querySelector<HTMLElement>(".form-popup-select");

        if (!input || !popup || !popupSelect) return;

        // показать popup
        function showPopup() {
            popup.style.display = "block";
            popup.style.pointerEvents = "auto";
            popup.style.animation = "fade-show .25s linear forwards";
        }

        // скрыть popup
        function hidePopup() {
            popup.style.display = "none";
        }

        // обновить класс add-element
        function updateFormItemClass() {
            if (popupSelect.children.length > 0) {
                formItem.classList.add("add-element");
            } else {
                formItem.classList.remove("add-element");
            }
        }

        // удалить текущий выбор
        function clearSelection() {
            popupSelect.innerHTML = "";
            input.value = "";
            popupItems.forEach((it) => it.classList.remove("active"));
            updateFormItemClass();
        }

        // 1) Фокус → показываем popup
        input.addEventListener("focus", () => {
            showPopup();
        });

        // 2) Клик по select → тоже показываем popup
        popupSelect.addEventListener("click", () => {
            showPopup();
            input.focus();
        });

        // 3) Фильтрация при вводе
        input.addEventListener("input", () => {
            const val = input.value.trim().toLowerCase();
            let hasVisible = false;

            popupItems.forEach((item) => {
                const text = item.textContent?.toLowerCase() ?? "";
                const match = text.includes(val);
                item.style.display = match ? "" : "none";
                if (match) hasVisible = true;
            });

            if (hasVisible) {
                showPopup();
            } else {
                hidePopup();
            }
        });

        // 4) Клик по элементу списка
        popupItems.forEach((item) => {
            item.addEventListener("click", () => {
                // очистим предыдущий выбор перед добавлением нового
                clearSelection();

                const clone = item.cloneNode(true) as HTMLElement;
                clone.classList.add("selected");

                // крестик
                const removeBtn = document.createElement("button");
                removeBtn.type = "button";
                removeBtn.className = "remove-selected";
                removeBtn.innerHTML = "<button class='icon'><svg><use xlink:href=\"/local/templates/expertclinics_redesign_v2/verstka_vlad_1/dist/images/sprite.svg#icon-close\"></use></svg></button>";
                clone.appendChild(removeBtn);

                popupSelect.appendChild(clone);
                updateFormItemClass();

                // вставляем текст в input
                const textEl = clone.querySelector(".form-popup-item-text");
                if (textEl) {
                    input.value = textEl.textContent ?? "";
                }

                // отмечаем оригинал как active
                item.classList.add("active");

                // удаление по крестику
                removeBtn.addEventListener("click", (e) => {
                    e.stopPropagation(); // ⛔️ предотвращаем закрытие модалки
                    clone.remove();
                    item.classList.remove("active");
                    updateFormItemClass();
                    input.value = "";
                });

                hidePopup();
            });
        });

        // 5) Закрытие при клике вне блока
        document.addEventListener("click", (e) => {
            if (!formItem.contains(e.target as Node)) {
                hidePopup();
            }
        });
    });
}
